import { render, staticRenderFns } from "./deviceKeepRecord.vue?vue&type=template&id=5fbefb00&scoped=true&"
import script from "./deviceKeepRecord.vue?vue&type=script&lang=js&"
export * from "./deviceKeepRecord.vue?vue&type=script&lang=js&"
import style0 from "./deviceKeepRecord.vue?vue&type=style&index=0&id=5fbefb00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbefb00",
  null
  
)

export default component.exports